import moment from "moment";

export const PageLayoutMetaData = {
	"ai-product": {
		title: "AI-powered Electronic Lab Notebook | Genemod ELN",
		description:
			"Revolutionize your lab with Modern Sample Inventory and Electronic Lab Notebook Software with Genemod, a convenient way to automate inventory and experiments.",
	},
	"why-genemod": {
		title: "Lab Management Software | LIMS | Genemod",
		description:
			"Integrated LIMS and Electronic Lab Notebook—manage inventory, track orders, organize research data, and analyze experiments with modern lab management software.",
	},
	lims: {
		title: "Laboratory Information Management Systems (LIMS) Software | Genemod",
		description:
			"Elevate lab efficiency and data management with our advanced Laboratory Information Management Systems (LIMS) Software. Explore Genemod today!",
	},
	"lims-software": {
		title: "Laboratory Information Management Systems (LIMS) Software | Genemod",
		description:
			"Elevate lab efficiency and data management with our advanced Laboratory Information Management Systems (LIMS) Software. Explore Genemod today!",
	},
	eln: {
		title: `Best Electronic Lab Notebook (ELN) Software ${moment().format(
			"yyyy"
		)} | Genemod`,
		description:
			"Elevate your lab's efficiency and research capabilities with Genemod's best Electronic Lab Notebook Software. Learn more about our software today!",
	},
	"professional-services": {
		title: "Professional services - Genemod",
		description:
			"Enhance your research efficiency with precise solutions and support by Genemod Specialists!",
	},
	"eln-software": {
		title: `Electronic Lab Notebook (ELN) Software | Genemod`,
		description:
			"Enhance your lab's efficiency and research capabilities with Genemod's best Electronic Lab Notebook Software. Learn more about our software today!",
	},
	//Product
	experiments: {
		title: `Lab Experiment Management Software | Genemod`,
		description:
			"Discover our user-friendly, cloud-based lab experiment management software and increase your research productivity and collaboration. Learn more here.",
	},
	"virtual-freezers": {
		title: `Lab Inventory Management Software | Genemod`,
		description:
			"Unlock seamless lab operations with Genemod's lab inventory management software. Increase both efficiency and precision with our trusted solution now!",
	},
	alerts: {
		title: `Laboratory Automation Systems - Genemod`,
		description:
			"Experience cutting-edge Laboratory Automation Systems with Genemod. Elevate lab efficiency with our intuitive solutions for streamlined automation!",
	},
	"molecular-biology-software": {
		title: `Empower your research, share, and record all in one user-friendly platform with Genemod, the best Molecular Biology Software & Tools. Learn more about it today.`,
		description:
			"Empower your research, share, and record all in one user-friendly platform with Genemod, the best Molecular Biology Software & Tools. Learn more about it today.",
	},
	integrations: {
		title: `Seamless Research Workflows | Genemod LIMS for Biopharma R&D`,
		description:
			"Genemod ensures seamless workflows and tailored integration options to elevate efficiency for adaptable and integrated lab operations. Explore more today.",
	},
	"lab-inventory-management-software": {
		title: "Best Lab Inventory Management Software - Genemod",
		description:
			"Unlock seamless lab operations with Genemod, the best lab inventory management software. Elevate efficiency and precision in research with our trusted solution!",
	},
	"ai-product": {
		title: "Modern Sample Inventory and Electronic Lab Notebook Software - Genemod",
		description:
			"Revolutionize your lab with Modern Sample Inventory and Electronic Lab Notebook Software with Genemod, a convenient way to automate inventory and experiments.",
	},
	security: {
		title: "Best Clinical Trial Management Software - Genemod",
		description:
			"Elevate your research with Genemod's trusted and advanced Clinical Trial Management Software, ensuring efficient, secure, and compliant trials. Learn more today",
	},
	//Feature
	"lab-consumables": {
		title: `Lab Consumables Research & Supplies Management - Genemod`,
		description:
			"Optimize lab consumables research and supplies management with Genemod to streamline operations for optimal efficiency in your lab.",
	},
	orders: {
		title: `Manage laboratory orders with Genemod's LIMS Software`,
		description:
			"Simplify order management in Biopharma LIMS with Genemod. Elevate efficiency in biopharmaceutical labs with our seamless and intuitive solution.",
	},
	equipments: {
		title: `Simplified Laboratory Equipment Management Software | Genemod`,
		description:
			"Ready to use Genemod? Our Equipment Scheduling, Booking, and Maintenance makes it convenient for research teams to acquire the equipment they need.",
	},
	reports: {
		title: `Best laboratory reports: Genemod Electronic Lab Notebook`,
		description:
			"Collaborate and enhance efficiency in your lab with our advanced live editing feature in Electronic Lab Notebook at Genemod! Learn more today.",
	},
	"lab-protocol": {
		title: `Manage lab protocols with Genemod's Electronic Lab Notebook`,
		description:
			"Simplify lab protocol management effortlessly with Genemod. Streamline operations and boost efficiency in your lab with our intuitive solution.",
	},
	insights: {
		title: "Life Science Data Insights - Genemod",
		description:
			"Elevate your research capabilities and data analysis efficiency with our advanced Life Science Data Insights at Genemod. Learn more today!",
	},
	security: {
		title: "Top-grade security for advanced R&D collaboration | Genemod",
		description:
			"Elevate your research with Genemod's trusted and advanced Clinical Trial Management Software, ensuring efficient, secure, and compliant trials. Learn more today",
	},
	//industry
	pharmaceutical: {
		title: "LIMS Alternative for Biopharma Companies | Genemod",
		description:
			"Revolutionize your Biopharma and pharmaceutical workflows with Genemod's Electronic Lab Notebook. Learn how our advanced solutions enhance collaboration.",
	},
	biotech: {
		title: "LIMS Alternative for Biopharma Companies | Genemod",
		description:
			"Genemod’s biopharmaceutical R&D platform is trusted by hundreds of biopharmaceutical innovators to accelerate their R&D.",
	},
	research: {
		title: "LIMS Alternative for Biopharma Companies | Genemod",
		description:
			"Genemod’s biopharmaceutical R&D platform is trusted by hundreds of biopharmaceutical innovators to accelerate their R&D.",
	},
	manufacturing: {
		title: "LIMS Alternative for Biopharma Companies | Genemod",
		description:
			"Genemod’s biopharmaceutical R&D platform is trusted by hundreds of biopharmaceutical innovators to accelerate their R&D.",
	},
	repository: {
		title: "LIMS Alternative for Biopharma Companies | Genemod",
		description:
			"Genemod’s biopharmaceutical R&D platform is trusted by hundreds of biopharmaceutical innovators to accelerate their R&D.",
	},
	services: {
		title: "LIMS Alternative for Biopharma Companies | Genemod",
		description:
			"Genemod’s biopharmaceutical R&D platform is trusted by hundreds of biopharmaceutical innovators to accelerate their R&D.",
	},
	startups: {
		title: "Electronic Lab Notebook (ELN) for Startups | Genemod",
		description:
			"Streamline workflows, foster collaboration, drive breakthroughs and empower your startup journey with Genemod's Electronic Lab Notebook (ELN) today!",
	},
	"academic-labs": {
		title: "Boost Productivity With ELN & LIMS Academic Labs - Genemod",
		description:
			"Supercharge productivity with Genemod's ELN & LIMS Academic Labs. Experience the next level of academic lab management! Learn more today. ",
	},
	"non-profit": {
		title: `Best Nonprofit LIMS Software - Genemod`,
		description:
			"Elevate efficiency, enhance collaboration, and drive impactful research in your nonprofit organization with Genemod's Nonprofit LIMS Software today!",
	},
	//team
	"research-and-development": {
		title: `R&D Lab Manager Software and Tools - Genemod`,
		description:
			"Elevate your R&D management with Genemod's Software and Tools for Lab Managers. Streamline operations, boost efficiency, and enhance collaboration in your lab.",
	},
	"lab-manager": {
		title: "Lab Manager LIMS Software | Genemod",
		description:
			"Empower your lab management with Genemod's Lab Manager LIMS Software. Streamline workflows, enhance efficiency, and elevate collaboration",
	},
	"life-science-project-management": {
		title: "Life Science Project Management Software",
		description:
			"Streamline collaboration, boost efficiency, and elevate your life science projects with Genemod's Project Management Software today!",
	},
	"clinical-research-compliance": {
		title: "Security Policy | Genemod",
		description:
			"Elevate your research with Genemod's trusted and advanced Clinical Trial Management Software, ensuring efficient, secure, and compliant trials. Learn more today",
	},
	//comparisons
	excel: {
		title: "Excel vs Genemod - The #1 Excel Alternative - Genemod",
		description:
			"Upgrade from Excel to Genemod, the #1 Excel Alternative. Experience advanced features, seamless collaboration, and efficient data management.",
	},
	quartzy: {
		title: "Quartzy vs Genemod - Genemod",
		description:
			"Discover the Genemod advantage over Quartzy. Choose Genemod for a superior lab management experience and elevate lab efficiency with our advanced features.",
	},
	labarchives: {
		title: "LabArchives vs Genemod - Genemod",
		description:
			"Choose Genemod over LabArchives for superior lab management. Experience the next level with advanced features and seamless collaboration with Genemod.",
	},
	//Pricing (annually / monthly)
	pricing: {
		title: "Plans and Pricing",
		description:
			"Discover Genemod's Plans and Pricing for tailored lab management solutions. Choose the perfect package to elevate efficiency and innovation in your lab.",
	},
	"affiliate-program": {
		title: "Refer Another Team and Save 20%",
		description:
			"Help us grow the Genemod family, earn a one-time 20% discount when you bring new teams onto the Genemod platform.",
	},
	news: {
		title: "Genemod’s Latest News & Developments",
		description:
			"Learn about the moves Genemod is making in the life science and research space!",
	},
	blog: {
		title: "Genemod Blog",
		description:
			"Stay updated with the latest in lab management and research innovations. Explore Genemod's Blog and News for insightful articles and updates. ",
	},
	"case-studies": {
		title: "Case Studies - Genemod",
		description:
			"Explore Genemod's success stories through compelling case studies. Discover how our solutions have transformed labs and boosted efficiency.",
	},
	"about-us": {
		title: "About Us",
		description:
			"Learn more about Genemod – your partner in advancing lab efficiency. Explore our commitment to innovation, collaboration, and streamlined solutions.",
	},
	policy: {
		title: "Master Subscription Agreement",
		description:
			"Your privacy matters to us. Explore Genemod's Privacy Policy for insights into how we protect and handle your data. Trust us to safeguard your information.",
	},
	careers: {
		title: "Careers at Genemod",
		description:
			"Explore exciting career opportunities at Genemod. Join a dynamic team committed to advancing lab management solutions at Genemod today!",
	},
	"contact-us": {
		title: "Contact Us",
		description:
			"Have questions or inquiries? Contact us for personalized assistance and discover how our lab management solutions can elevate your research.",
	},
	demo: {
		title: "Request Demo",
		description:
			"Experience the power of Genemod! Request a demo today and discover how our lab management solutions can elevate efficiency, collaboration, and innovation.",
	},

	"system-status": {
		title: "Genemod System Status",
		description: "Genemod System Status",
	},
	academia: {
		title: [
			"Apply for Academia Pro",
			"Apply for Academia Pro | Contact",
			"Apply for Academia Pro | Details",
			"Apply for Academia Pro | Use",
			"Apply for Academia Pro | Summary",
		],
		description: "",
	},
	institution: {
		title: [
			"Apply as Institution",
			"Apply as Institution | Contact",
			"Apply as Institution | Institution",
			"Apply as Institution | Use",
			"Apply as Institution | Summary",
		],
		description: "",
	},
	"404": {
		title: "Page not found",
		description: "",
	},
	"privacy-policy": {
		title: "Privacy Policy",
		description:
			"Your privacy matters to us. Explore Genemod's Privacy Policy for insights into how we protect and handle your data. Trust us to safeguard your information.",
	},
	msa: {
		title: "Master Subscription Agreement",
		description:
			"Explore the terms of Genemod's Master Subscription Agreement. Discover the framework for leveraging our advanced lab management solutions",
	},
	dpa: {
		title: "Data Processing Addendum",
		description: "Explore Genemod's Data Processing Addendum .",
	},
	"terms-of-service": {
		title: "Terms of Service",
		description:
			"Explore the terms of Genemod's Terms of Service and understand the agreement that governs your use of our innovative lab management solutions today.",
	},
} as const;

export type SeoPage = keyof typeof PageLayoutMetaData;
